import { EntityDefinition } from '../types/entity-definition.interface';
import { Graph } from '../types/graph.interface';

export const graphDefinition: EntityDefinition<Graph> = {
  entityType: 'Graph',
  i18nBase: 'entities.graph',
  enableFiltering: true,
  defaultSortField: 'name',
  defaultSortOrder: 1,
  list: {
    columns: [
      {
        field: 'name',
        headerKey: 'entities.graph.fields.name',
        sortable: true,
        filterable: true,
        class: 'min-w-[200px]',
        contentClass: 'line-clamp-1',
        showTooltip: true,
      },
      {
        field: 'description',
        headerKey: 'entities.graph.fields.description',
        sortable: true,
        filterable: true,
        class: 'min-w-[250px]',
        contentClass: 'line-clamp-1',
        showTooltip: true,
      },
      {
        field: 'type',
        headerKey: 'entities.graph.fields.type',
        sortable: true,
        filterable: 'select',
        class: 'min-w-[150px]',
        template: 'optionValue',
        options: [
          { labelKey: 'entities.graph.types.evTemp', value: 1 },
          { labelKey: 'entities.graph.types.multiYear', value: 2 },
          { labelKey: 'entities.graph.types.xy', value: 3 },
        ],
      },
      {
        field: 'measures',
        headerKey: 'entities.graph.fields.measures',
        sortable: false,
        filterable: true,
        class: 'min-w-[300px]',
        contentClass: 'line-clamp-1',
        showTooltip: true,
      },
    ],
  },
  actionButtons: {
    parent: {
      add: false,
      edit: false,
      delete: false,
      custom: [
        {
          icon: 'more_vert',
          action: 'menu',
          tooltipKey: 'common.labels.actions',
          tooltipPosition: 'bottom',
          hasPermission: { method: 'putGraphicDetailResource' },
        },
      ],
    },
  },
  messages: {
    dialogTitles: {
      create: () => 'entities.graph.messages.createTitle',
      edit: () => 'entities.graph.messages.editTitleWithName',
      delete: () => 'common.confirmations.deleteTitleWithName',
    },
    buttons: {
      add: () => 'entities.graph.messages.addButton',
      create: () => 'entities.graph.messages.addButton',
      edit: () => 'entities.graph.messages.editTitleWithName',
      delete: () => 'entities.graph.messages.deleteTitle',
    },
    confirmDelete: () => 'entities.graph.messages.deleteConfirm',
  },
};
